// extracted by mini-css-extract-plugin
export var csatScore = "_lt-5";
export var header = "_lt-1";
export var panelWrapper = "_lt-2";
export var postPreview = "_lt-3";
export var rightContent = "_lt-0";
export var wrappingText = "_lt-4";